/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { get } from 'utils/lodash'

// Calculate dynamic panel size based on browser width
const calculateDynamicPanelSizes = () => {
  const browserWidth = window.innerWidth
  const desiredPercentage = 25
  const maxWidthInPixels = 400

  // Calculate what 25% would be in pixels
  const percentageInPixels = (browserWidth * desiredPercentage) / 100

  // If 25% is more than 400px, calculate the percentage that equals 400px
  let locationsPanelSize
  if (percentageInPixels > maxWidthInPixels) {
    locationsPanelSize = (maxWidthInPixels / browserWidth) * 100
  } else {
    // Otherwise, use 25%
    locationsPanelSize = desiredPercentage
  }

  return {
    locationsPanel: locationsPanelSize,
    servicesPanel: 100 - locationsPanelSize,
  }
}

const initialState = {
  isLocationsPanelOpen: true,
  panelSizes: calculateDynamicPanelSizes(),
}

const customerDetailsServicesSlice = createSlice({
  name: 'persistentCustomerDetailsServices',
  initialState: { ...initialState },
  reducers: {
    setIsLocationsPanelOpen: (state, action) => {
      state.isLocationsPanelOpen = action.payload
    },
    setPanelSizes: (state, action) => {
      state.panelSizes = action.payload
    },
    resetState: () => initialState,
  },
})

export const { setIsLocationsPanelOpen, setPanelSizes, resetState } = customerDetailsServicesSlice.actions

export const selectIsLocationsPanelOpen = state =>
  get(state, 'persistentCustomerDetailsServices.isLocationsPanelOpen', initialState.isLocationsPanelOpen)

export const selectPanelSizes = state => get(state, 'persistentCustomerDetailsServices.panelSizes', initialState.panelSizes)

export default customerDetailsServicesSlice.reducer
